import { ErrorHandler, RequestOptions } from 'common/models/GenericTypes';
import { UserTraining } from 'common/models/UserTraining';
import { Get } from 'util/HttpUtils';

export async function GetNextSessions(errorHandler?: ErrorHandler) {
  const options: RequestOptions = {
    errorHandler,
  };

  return Get<UserTraining[]>('api/UserTraining', options);
}
